var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['IM_2_' + this.id]},[_c('div',{staticClass:"w-100 p-3",staticStyle:{"text-align":"center","height":"92.3vh"}},[_c('vue-word-cloud',{staticStyle:{"height":"74.5vh"},attrs:{"words":_vm.word_cloud,"color":_vm.randomColors,"font-size-ratio":4,"rotation":function (ref) {
	var weight = ref[1];

	return (Math.random() > 0.6 ? 1 : 0.75);
},"spacing":0.35,"font-family":"Faune"}})],1),_c('NextBtn',{staticClass:"send",attrs:{"url":'/immersion02/' + (this.id + 1),"text":"Rejoindre Léon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }